<script>
    import AccountFlagsView from "../Accounts/Flags.vue"

    export default {
        extends: AccountFlagsView,
        methods: {
            saveForm() {
                axios.put(route('containers.account_flags', this.$route.params.containerId), {
                    defaultAccountFlags: this.flags,
                }).then(response => {
                    this.$bus.$emit('alert.success', 'Update Success')
                })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Update Failed')
                });
            },
        }
    }
</script>